module.exports = __webpack_public_path__ + "img/湖南中南二手车工程机械交易管理有限公司.e3028ace.jpg";